import HBIcon from "@/components/HBIcon";
import { PinEditorModal } from "@/components/PinEditor";
import { EVENT } from "@/constants/event";
import { openBindTelModal } from "@/utils/open";
import { Button } from "antd";
import { useCallback } from "react";
import styles from "./index.module.less";

interface IProp {
  pin: IPin;
  onUpdatePin: (pin: IPin) => void;
  size?: number;
  circle?: boolean;
}

/**
 * 编辑按钮
 * */
export default function PurePinEdit({
  pin,
  onUpdatePin,
  size,
  circle = false,
}: IProp) {
  const onEdit = useCallback(async () => {
    await openBindTelModal();

    PinEditorModal.open({
      pinId: pin?.pin_id,
      onOk: (data: IPin) => onUpdatePin({ ...pin, ...data, user: pin.user }),
      onDelete: () => {
        window.dispatchEvent(
          new CustomEvent(EVENT.DELETE_PIN, { detail: pin.pin_id })
        );
      },
    });
  }, [onUpdatePin, pin]);

  return (
    <Button
      className={styles.edit}
      onClick={onEdit}
      data-gd-click="button_click"
      data-board-id={pin?.board_id}
      data-content-id={pin?.pin_id}
      data-button-name="编辑"
      data-file-id={pin?.file_id}
      data-ext={JSON.stringify(pin?.ext)}
      data-tooltip="编辑"
      data-tooltip-position="bottom"
      style={{
        width: size || 40,
        height: size || 40,
        borderRadius: circle ? "50%" : "12px",
      }}
    >
      <HBIcon type="ic_edit" />
    </Button>
  );
}
